export default "__VITE_ASSET__DuG9N6m9__"